// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"f094d99f","453":"c92c05ba","672":"79cc4c56","952":"20f9eb97"}[chunkId] + ".chunk.js";
};